import { PropsWithChildren, useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { User } from '../../shared/models/user.model';
import { UserContext } from '../contexts/user-context';

interface Props extends PropsWithChildren {
   profileUrl?: string;
   user?: User;
}

export const UserProvider = ({ profileUrl = '/auth/profile', user: initialUser, children }: Props) => {
   const {
      data: user,
      isLoading: isLoadingUser,
      refetch
   } = useQuery({
      queryKey: ['profile'],
      queryFn: async () => {
         const response = await fetch(profileUrl);

         if (!response.ok) {
            throw new Error('Failed to fetch user profile');
         }

         const result: User = await response.json();
         return result;
      },
      initialData: initialUser
   });

   const contextValue = useMemo(
      () => ({
         user: user,
         isLoading: isLoadingUser,
         invalidate: async () => {
            await refetch();
         }
      }),
      [user, isLoadingUser, refetch]
   );

   return <UserContext value={contextValue}>{children}</UserContext>;
};
